export { default } from './Cabinet';
